import { ExternalLink } from 'lucide-react';
import { useTranslation } from '../../../lib/i18n';
import { useIsPhone } from '../../../lib/use-is-phone';
import { openSitePane, useSiteChatBinding } from '../../../lib/site-edit-store';
import { useSitePaneFits } from '../../../lib/use-site-pane';
import { TextButton } from '../ui';
import styles from './SitePreviewLink.module.css';

/**
 * "Preview site" on the chat's working line, while the agent works in a chat that is about a Symphony site (a
 * site-chat binding, `lib/site-edit-store.ts`). A phone opens the live site in a new tab; a computer opens the
 * preview pane beside the chat. The Space's "View site" stays the permanent link. Same on iOS and Android.
 */
export function SitePreviewLink({ conversationId }: { conversationId: string | null }) {
  const { t } = useTranslation();
  const binding = useSiteChatBinding(conversationId);
  const phone = useIsPhone();
  const fits = useSitePaneFits();
  if (!binding || !conversationId) return null;
  const label = t('siteReview.action.preview');
  if (phone || !fits) {
    return (
      <TextButton size="small" href={binding.previewUrl} external target="_blank" rel="noopener noreferrer" className={styles.link} data-testid="sitePreviewLink" endIcon={<ExternalLink size={14} aria-hidden />}>
        {label}
      </TextButton>
    );
  }
  return (
    <TextButton
      size="small"
      className={styles.link}
      data-testid="sitePreviewLink"
      onClick={() => openSitePane({ workspaceId: binding.workspaceId, previewUrl: binding.previewUrl, conversationId })}
    >
      {label}
    </TextButton>
  );
}
